import { CircularProgress, Grid, MenuItem } from '@material-ui/core';

import { Backdrop, Select } from '@room-match/shared-ui-components';
import { useEffect } from 'react';
import { IProfile } from 'shared/interfaces/IProfile';
import { profileService } from 'shared/services/profileService';

import { useStyles } from './Information.styles';
import { ISingleProjectResponsePayload } from 'shared/interfaces/IProject';
import { projectService } from 'shared/services/projectService';
import React from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';

type Props = {
  projectId: string;
  projectName?: string;
  pData?: ISingleProjectResponsePayload;
  form: any;
  createIsLoading: boolean;
  country: string;
};

const { getProfiles } = profileService();
const { getSingleProject } = projectService();

const Information: React.FC<Props> = ({ projectId, projectName, pData, form, createIsLoading, country }) => {
  const classes = useStyles();
  const { data: profileList, isLoading } = getProfiles();
  const { data: pDataSpare, isLoading: isLoadingSpareData } = getSingleProject(projectId);

  const roleList = pData?.data?.attributes.ongoing_session.data?.attributes.casting_roles.map((i) => i);

  useEffect(() => {
    if (pData) {
      const roles = pData?.data?.attributes.ongoing_session.data?.attributes.casting_roles;
      if (roles?.length === 1) {
        form.setFieldValue('role_id', roles[0].id);
      }
    } else {
      const roles = pDataSpare?.data?.attributes.ongoing_session.data?.attributes.casting_roles;
      if (roles?.length === 1) {
        form.setFieldValue('role_id', roles[0].id);
      }
    }
  }, [pData]);

  useEffect(() => {
    if (profileList) {
      const profile = profileList.data;
      console.log({ profile });

      if (profile?.length === 1) {
        console.log(profile[0].id);
        form.setFieldValue('profile_id', profile[0].id);
      }
    }
  }, [profileList]);

  const profile = () =>
    profileList?.data.map((i: IProfile) => {
      const hasDivisions = i.attributes.division?.data;
      const key = hasDivisions
        ? `${i.attributes?.agency_full_name || i.attributes.agency_name} - ${
            i.attributes.division.data.attributes.name
          }`
        : i.attributes?.agency_full_name ||
          i.attributes.agency_name ||
          (country !== 'au' ? 'Personal Profile' : 'Freelance');
      return { value: i.id, key };
    }) || [{ key: '', value: '' }];

  const role = () =>
    roleList?.map((r) => {
      return { value: r.id, key: r.name };
    }) || [{ key: '', value: '' }];

  if (isLoading) return <Backdrop isLoading />;
  return (
    <Grid className={classes.root}>
      {!createIsLoading ? (
        <>
          <Grid item>
            <Grid item className={classes.selection}>
              {(profile()?.length > 1 || profile()?.length === 0) && (
                <Grid item>
                  <p style={{ fontSize: 16 }}>Select Your Representation For This Audition:</p>
                  <Select
                    disabled={profileList && profileList?.data.length === 1}
                    variant="outlined"
                    fullWidth
                    error={!form.values.profile_id}
                    data={profile()}
                    value={form.values.profile_id}
                    className={classes.select}
                    renderValue={(value) => {
                      const item = profileList?.data.find((f: IProfile) => f.id === value);
                      const agency =
                        item?.attributes?.agency_full_name || item?.attributes?.agency_name || 'Non-Represented';
                      const division =
                        item?.attributes.division?.data && item?.attributes.division?.data.attributes.name;
                      return form.values.profile_id ? (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <CustomTypography fontWeight={500}>{agency}</CustomTypography>
                          {division ? (
                            <CustomTypography fontSize={12} fontWeight={700}>{`${division}`}</CustomTypography>
                          ) : (
                            <React.Fragment />
                          )}
                        </div>
                      ) : (
                        <p style={{ fontSize: 14, color: 'darkgrey' }}>Select Representation</p>
                      );
                    }}
                    name="profile_id"
                    renderMenu={(item) => {
                      const agency = item.key.split(' - ')[0];
                      const division = item.key.split(' - ')[1];
                      return (
                        <MenuItem
                          style={{ background: item.value === form.values.profile_id ? COLORS.PRIMARY : 'unset' }}
                          onClick={() => form.setFieldValue('profile_id', item.value)}
                        >
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <CustomTypography fontWeight={500}>{agency}</CustomTypography>
                            {division ? (
                              <CustomTypography fontSize={12}>{`${division}`}</CustomTypography>
                            ) : (
                              <React.Fragment />
                            )}
                          </div>
                        </MenuItem>
                      );
                    }}
                  />
                </Grid>
              )}
              {(role()?.length > 1 || role()?.length === 0) && (
                <Grid item>
                  <p style={{ fontSize: 16 }}>Select The Role You Are Auditioning For:</p>
                  <Select
                    error={!form.values.role_id}
                    variant="outlined"
                    fullWidth
                    data={role()}
                    value={form.values.role_id}
                    className={classes.select}
                    name="role_id"
                    onChange={form.handleChange}
                    renderValue={(value: any) =>
                      value?.length ? (
                        role().find((f) => f.value === value)?.key
                      ) : (
                        <p style={{ color: 'darkgray' }}>Select Role</p>
                      )
                    }
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      ) : (
        <CircularProgress style={{ alignSelf: 'center' }} />
      )}
    </Grid>
  );
};

export default Information;
